import type { RefObject } from 'react'

import { useEffect, useRef, useState } from 'react'
import { observeElement } from '@/lib/observe'

type InViewOptions = {
    once?: boolean
    rootMargin?: string
    threshold?: number
}

export const useInView = <T extends Element = HTMLDivElement>(options: InViewOptions = {}): { ref: RefObject<T | null>, inView: boolean } => {
    const { once = true, rootMargin = '0px 0px -12% 0px', threshold = 0 } = options
    const ref = useRef<T>(null)
    const [inView, setInView] = useState(false)

    useEffect(() => {
        const node = ref.current

        if (!node) return

        let stop = () => {}

        stop = observeElement(node, entry => {
            if (entry.isIntersecting) {
                setInView(true)

                if (once) stop()
            }
            else if (!once) {
                setInView(false)
            }
        }, { rootMargin, threshold })

        return () => stop()
    }, [once, rootMargin, threshold])

    return { ref, inView }
}
